var React = require('react');

function SoundOff (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m337.83 340.888c5.857 5.858 15.355 5.859 21.213 0l63.676-63.676 63.676 63.676c5.857 5.857 15.355 5.859 21.213 0 5.858-5.858 5.858-15.355 0-21.213l-63.677-63.675 63.676-63.676c5.858-5.858 5.858-15.355 0-21.213-5.857-5.858-15.355-5.858-21.213 0l-63.676 63.676-63.676-63.676c-5.858-5.858-15.356-5.858-21.213 0-5.858 5.858-5.858 15.355 0 21.213l63.676 63.676-63.676 63.676c-5.857 5.858-5.857 15.355.001 21.212z","key":0}),React.createElement("path",{"d":"m15 146.429h60v219.14h-60c-8.28 0-15-6.71-15-15v-189.14c0-8.29 6.72-15 15-15z","key":1}),React.createElement("path",{"d":"m303.81 78.589v354.82c0 21.57-23.12 35.24-42.01 24.83l-156.8-86.32v-231.84l156.8-86.32c18.9-10.41 42.01 3.27 42.01 24.83z","key":2})]);
}

SoundOff.defaultProps = {"height":"1em","viewBox":"0 0 512 512","width":"1em"};

module.exports = SoundOff;

SoundOff.default = SoundOff;
